// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"aff24bda","527":"641a797c","838":"d0463b35"}[chunkId] + ".chunk.js";
};